// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3t658","errors":"Errors_errors__2ekOT"};